import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class MovuRobotics_ds_get_movetask_by_licensePlateIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lookupCode: string }): 
  Promise<{ result: { Id?: number, LocationId?: number, LookupCode?: string, TasksForExpectedSourceLicensePlate?: { Id?: number, ActualSourceLicensePlateId?: number, ActualTargetLocationId?: number, CreatedSysDateTime?: string, ExpectedSourceLocationId?: number, ExpectedTargetLocationId?: number }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookupCode)) {
      $missingRequiredInParams.push('\'lookupCode\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { lookupCode: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LocationId?: number, LookupCode?: string, TasksForExpectedSourceLicensePlate?: { Id?: number, ActualSourceLicensePlateId?: number, ActualTargetLocationId?: number, CreatedSysDateTime?: string, ExpectedSourceLocationId?: number, ExpectedTargetLocationId?: number }[] }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookupCode)) {
      $missingRequiredInParams.push('\'lookupCode\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { lookupCode: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LocationId?: number, LookupCode?: string, TasksForExpectedSourceLicensePlate?: { Id?: number, ActualSourceLicensePlateId?: number, ActualTargetLocationId?: number, CreatedSysDateTime?: string, ExpectedSourceLocationId?: number, ExpectedTargetLocationId?: number }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookupCode)) {
      $missingRequiredInParams.push('\'lookupCode\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lookupCode: string    }) {
        if(isNil($inParams.lookupCode)) {
          return true; 
        }
      return false;
    }
}
